import classNames from 'classnames'

import { Avatar, AVATAR_HEIGHT_48 } from '../../Avatar'
import { Headline2 } from '../../Headline2'
import { ModalResizeButton } from '../../Modal'

import * as styles from './ChatroomHeader.module.css'

import ChatsIcon from '../../../icons/chats.svg'

function ChatroomHeader({
  additionalIcons,
  className = styles.ChatroomHeader,
  isFullScreen,
  title,
  onToggleFullScreen,
}) {
  const titleClassName = classNames(styles.title, {
    [styles.titleFullScreen]: isFullScreen,
  })

  return (
    <div className={className}>
      <div className={styles.titleSection}>
        <Avatar Icon={ChatsIcon} size={AVATAR_HEIGHT_48} />
        <Headline2 className={titleClassName}>{title}</Headline2>
        {additionalIcons}
      </div>
      {onToggleFullScreen ? (
        <div className={styles.actions}>
          <ModalResizeButton
            isFullScreen={isFullScreen}
            onClick={onToggleFullScreen}
          />
        </div>
      ) : null}
    </div>
  )
}

export default ChatroomHeader
